import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-53-shardul-kulkarni-guest.webp";
import ThumbImg from "../../assets/images/conversations/053.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: sk-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .sk-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .sk-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .sk-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .sk-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .sk-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .sk-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sk-hero__title.sk-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .sk-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .sk-hero__spotify.sk-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .sk-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .sk-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .sk-hero__right.sk-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .sk-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .sk-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .sk-yt-thumb:hover img { opacity: 0.85; }
  .sk-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .sk-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .sk-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .sk-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .sk-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sk-body.sk-visible { opacity: 1; transform: translateY(0); }
  .sk-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .sk-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .sk-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sk-guest.sk-visible { opacity: 1; transform: translateY(0); }
  .sk-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .sk-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .sk-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .sk-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .sk-inner { padding-left: 32px; padding-right: 32px; }
    .sk-hero { padding-top: 32px; padding-bottom: 48px; }
    .sk-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .sk-hero__title { font-size: 24px; }
    .sk-hero__left { gap: 16px; }
    .sk-guest__title { font-size: 24px; margin-bottom: 24px; }
    .sk-guest__photo-bg { width: 260px; height: 300px; }
    .sk-guest__name { font-size: 24px; margin-top: 18px; }
    .sk-body__para { font-size: 14px; margin-bottom: 12px; }
    .sk-body { padding-bottom: 48px; }
    .sk-guest { padding-bottom: 48px; }
    .sk-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .sk-inner { padding-left: 16px; padding-right: 16px; }
    .sk-hero { padding-top: 51px; padding-bottom: 30px; }
    .sk-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .sk-hero__left { gap: 30px; }
    .sk-hero__title { font-size: 30px; }
    .sk-body__para { font-size: 16px; margin-bottom: 10px; }
    .sk-guest__title { font-size: 30px; margin-bottom: 20px; }
    .sk-guest__photo-bg { width: 100%; height: 386px; }
    .sk-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .sk-body { padding-bottom: 30px; }
    .sk-guest { padding-bottom: 30px; }
    .sk-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sk-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "_AEBDZ9rsoI";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="sk-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 53 Shardul Kulkarni"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="sk-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 53 Shardul Kulkarni thumbnail" />
      <div className="sk-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="sk-hero">
      <div className="sk-inner">
        <div className="sk-hero__grid">
          <div className="sk-hero__left">
            <h1 ref={titleRef} className="sk-hero__title">
              EP 53 | Industrial Decarbonisation with Green Hydrogen | Shardul Kulkarni
            </h1>
            <div ref={spotifyRef} className="sk-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/571B8ZDKTURXRtAxOQiTIb?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 53 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="sk-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="sk-body">
      <div className="sk-inner">
        <p className="sk-body__para">
          In his Independence Day address, Prime Minister Narendra Modi reaffirmed the government's commitment to establishing India as a global leader in green hydrogen through the National Green Hydrogen Mission. In just a year and a half, this mission has placed the hydrogen molecule at the forefront of discussions among energy developers, investors, policymakers, and industry leaders. The introduction of production-linked incentives, along with significant capital investment for electrolyzer manufacturers and developers of green hydrogen and green ammonia, has bolstered confidence in India's ability to achieve its hydrogen production goals. However, there is ongoing concern among developers about the demand and market uptake for their products. Today, we are pleased to welcome Shardul Kulkarni, Managing Director and CEO of Deesha Power. With 20 years of experience in the power and renewable energy sectors, Shardul has been instrumental in driving over $1 billion in energy transition investments across Southeast Asia and Western Africa. Within the Indian green hydrogen community, Shardul is affectionately known as the "hydrogen wala," a passionate advocate for green hydrogen, dedicated to raising awareness and educating others about the vast potential of this transformative energy source.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="sk-guest">
      <div className="sk-inner">
        <h2 className="sk-guest__title">Our Guest</h2>
        <div>
          <div className="sk-guest__photo-bg">
            <img src={GuestImg} alt="Shardul Kulkarni" />
          </div>
          <p className="sk-guest__name">Shardul Kulkarni</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep53ShardulKulkarni() {
  return (
    <>
      <style>{CSS}</style>
      <div className="sk-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}